export enum CalendarMeetingLinkTypeKey {
  INTAKE = 'intake',
  GUIDANCE = 'guidance',
  WILL_REVIEW = 'will_review',
  WILL_NOTARIZATION = 'will_notarization',
  PROTECTION_MANDATE_NOTARIZATION = 'protection_mandate_notarization',
  WILL_AND_PROTECTION_MANDATE_NOTARIZATION = 'will_and_protection_mandate_notarization',
  REFERRAL_CONSULT = 'referral_consult',
  PROTECTION_MANDATE_REVIEW = 'protection_mandate_review',
  PROTECTION_MANDATE_GUIDANCE = 'protection_mandate_guidance',
  PROTECTION_MANDATE = 'protection_mandate',
  LIQUIDATOR = 'liquidator',
  WILL_APPOINTMENT_OF_LIQUIDATOR = 'will_appointment_of_liquidator',
  WILL_LEGATEE = 'will_legatee',
  WILL_LIQUIDATOR_LEGATEE = 'will_liquidator_legatee',
  ANNUAL_REVIEW = 'annual_review'
}
